import { AppNS } from 'app';
import { updateCacheItemPropInCollection } from 'app/core/cache/helpers';
import { SPECIAL_TEMP_TICKET_ID } from 'app/main/agency/inspector-profile/qualifications-sections/sections/disciplines/helpers';
import { WebsocketMessage } from 'app/types';
import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

export interface DisciplineBlockingTicketsProps {
  message: WebsocketMessage;
}

export default function DisciplineBlockingTickets(props: DisciplineBlockingTicketsProps) {
  const { message } = props;

  const queryClient = useQueryClient();

  useEffect(() => {
    if (!message.model || message?.model?.error) {
    } else {
      if (message.model.inspector_discipline_id) {
        const queryKey = ['inspectorDisciplines', message.model.user_id];

        const previousState = queryClient.getQueryData(queryKey) as AppNS.InspectorDiscipline[];
        if (!previousState) {
          return;
        }

        const discipline = previousState.find((item) => item.id === message.model.inspector_discipline_id);
        if (!discipline) {
          return;
        }

        // Remove temporary ticket if exists
        let updatedTickets = discipline.pendingTickets?.filter((ticket) => ticket.id !== SPECIAL_TEMP_TICKET_ID);

        updateCacheItemPropInCollection<AppNS.InspectorDiscipline>(
          queryClient,
          queryKey,
          'id',
          message.model.inspector_discipline_id,
          {
            pendingTickets: [...(updatedTickets || []), message.model.blocking_ticket],
            // to trigger state change in Disciplines
            updatedAt: new Date().toISOString(),
          }
        );
      }
    }
  }, [message.uuid]);

  return null;
}
